import React, { memo, TextareaHTMLAttributes, useEffect, useState } from 'react'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import './InputArea.scss'
const rootClassName = 'component-input-area'

interface InputAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  onChange?: (event: any) => void
  value?: string | number
  loading?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: string
  label?: string
  placeholder?: string
  type?: string
  counter?: boolean
  maxLength?: number
  rightObject?: React.ReactNode
  hideLabelAndHelperText?: boolean
  forceFocus?: boolean
}

function InputArea(props: InputAreaProps) {
  const [id] = useState(props.id ? props.id : getUniqueKey())
  const getProps = () => {
    const p = {
      ...props,
      rows: 1,
      id: id ? `${id}-input` : undefined,
      className: getMergedClassNames([
        'nunito',
        `${rootClassName}-input-area`,
        props.className || ''
      ])
    }
    delete p.loading
    delete p.error
    delete p.helperText
    delete p.label
    delete p.counter
    delete p.rightObject
    delete p.hideLabelAndHelperText
    delete p.forceFocus
    return p
  }

  useEffect(() => {
    const inputArea = document.querySelector(
      `#${id} textarea`
    ) as HTMLTextAreaElement
    if (inputArea) {
      inputArea.style.height = `auto`
      inputArea.style.height = `${inputArea.scrollHeight}px`
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value])

  const getContainerClassNames = () =>
    getMergedClassNames([
      rootClassName,
      props.error ? `${rootClassName}-error` : '',
      props.loading ? `${rootClassName}-loading` : '',
      props.disabled ? `${rootClassName}-disabled` : '',
      props.forceFocus ? 'force-focus' : ''
    ])

  return (
    <div id={id} className={getContainerClassNames()}>
      {!props.hideLabelAndHelperText && (
        <div className={`${rootClassName}-label nunito`}>
          {props.label || ''}
        </div>
      )}
      <div className={`${rootClassName}-input-container`}>
        <textarea {...getProps()} />
        {props.rightObject && (
          <div className={`${rootClassName}-right-object`}>
            {props.rightObject}
          </div>
        )}
      </div>
      {!props.hideLabelAndHelperText && (
        <div className={`${rootClassName}-helper-and-counter`}>
          <div className={`${rootClassName}-helper-text nunito`}>
            {props.helperText || ''}
          </div>
          {props.counter && (
            <div className={`${rootClassName}-counter`}>
              {`${String(props.value || '').length}${
                props.maxLength || props.maxLength === 0
                  ? `/${props.maxLength}`
                  : ''
              }`}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

InputArea.defaultProps = {
  onChange: () => {},
  value: '',
  loading: false,
  error: false,
  helperText: '',
  label: '',
  placeholder: '',
  type: 'text',
  forceFocus: false
}

export default memo(InputArea)
